export default __webpack_public_path__ + "static/media/404-illustration.28d47405.svg";